// extracted by mini-css-extract-plugin
export default {"stack":"punch-details-tab_stack__PgmcP","panel":"punch-details-tab_panel__pbQce","employeeSelect":"punch-details-tab_employeeSelect__gUrrw"};